module.exports = __webpack_public_path__ + "static/17-897476942722554a808060f58a7a53c5.png";